"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ActivityFilterProps {
  filterAction: string;
  filterModule: string;
  onFilterActionChange: (value: string) => void;
  onFilterModuleChange: (value: string) => void;
}

export function ActivityFilter({
  filterAction,
  filterModule,
  onFilterActionChange,
  onFilterModuleChange,
}: ActivityFilterProps) {
  return (
    <Card className="border-0 shadow-sm">
      <CardContent className="pt-6">
        <div className="flex gap-4">
          <div className="flex-1">
            <Label>Filter by Action</Label>
            <Select value={filterAction} onValueChange={onFilterActionChange}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Actions</SelectItem>
                <SelectItem value="CREATE">Create</SelectItem>
                <SelectItem value="UPDATE">Update</SelectItem>
                <SelectItem value="DELETE">Delete</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex-1">
            <Label>Filter by Module</Label>
            <Select value={filterModule} onValueChange={onFilterModuleChange}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Modules</SelectItem>
                <SelectItem value="USER">User</SelectItem>
                <SelectItem value="STAFF">Staff</SelectItem>
                <SelectItem value="CUSTOMER">Customer</SelectItem>
                <SelectItem value="APPOINTMENT">Appointment</SelectItem>
                <SelectItem value="SUBSCRIPTION">Subscription</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

